import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextSize: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-size"><path d="M6.92969 20.25V10.999" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M22.25 4.75H9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M12.25 11H1.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M16 5V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconTextSize;
